import { path } from "@routes/path";
import type { IAppointmentPageType } from "@/pages/panelPages/appointment/types";
import { IAppointmentPageTypeEnum } from "@/pages/panelPages/appointment/types";

export const extractSearchFromUrl = (request: Request) => {
  return new URL(request.url)?.searchParams;
};

export const fromHandling = {
  getCreateAppointmentPossiblePath() {
    // this will give you array of enum keys.
    const apptTypeKeys = Object.keys(IAppointmentPageTypeEnum).filter((item) =>
      Number.isNaN(Number(item)),
    );

    return apptTypeKeys.map((item) =>
      path.appointment.create.link(item as IAppointmentPageType),
    );
  },
  isKindOfCreateAppointmentPath(request: Request) {
    const pathname = new URL(request.url).pathname;

    for (const path of this.getCreateAppointmentPossiblePath()) {
      if (
        pathname?.replaceAll("_", "-").includes(path) &&
        request.url.includes("fromWebsite=true")
      )
        return true;
    }
    return false;
  },
  fromParmaName: "from",
  /**
   * return `from` param to set in the url (only for make-appointment page)
   * @param request
   * @returns
   */
  createFromParam(request: Request) {
    if (this.isKindOfCreateAppointmentPath(request)) {
      const params = new URLSearchParams();

      const url = new URL(request.url);

      const result = url.searchParams
        ? `${url.pathname}?${url.searchParams}`
        : url.pathname;

      params.set(this.fromParmaName, result);
      return params.toString();
    }
    return "";
  },

  /**
   * read and return 'from' parma from the url
   * @param request
   * @returns
   */
  getFromParmaValue(request: Request) {
    const params = new URL(request.url).searchParams;

    return params.get(this.fromParmaName);
  },
};
